var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import { translate } from '@utils/i18n';
import Brushaway from '../../../../components/Brushaway';
import TextInput from '@components/TextInput/TextInput';
import { namespace } from './constants';
function GocanvasFormDetail({ form, onClose, onSubmit }) {
    const [editForm, setEditForm] = useState(form);
    useEffect(() => {
        if (form)
            setEditForm(form);
    }, [form]);
    const handleSubmitForm = () => __awaiter(this, void 0, void 0, function* () {
        if (editForm) {
            return onSubmit(editForm);
        }
        return false;
    });
    const handleNameChange = (event) => {
        if (editForm) {
            setEditForm(Object.assign(Object.assign({}, editForm), { displayName: event.target.value }));
        }
    };
    return (React.createElement(Brushaway, { open: form !== null, title: translate('detail.edit_title', { namespace }), isForm: true, onClose: onClose, onSubmit: handleSubmitForm },
        React.createElement("div", null,
            React.createElement("div", null,
                React.createElement(TextInput, { id: "name", value: (editForm === null || editForm === void 0 ? void 0 : editForm.displayName) || '', label: translate('detail.name_label', { namespace }), onChange: handleNameChange })))));
}
export default GocanvasFormDetail;
